var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton2026(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 64,
    viewBox: "0 0 350 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 64,
    rx: 32,
    fill: "#E40039"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.119 20.11H127.671V39.69H125.119V20.11ZM118.849 22.354H110.665V20.11H121.401V39.69H118.849V22.354ZM148.128 33.86H141.594V37.248H149.228V39.492H131.408V37.248H139.042V33.86H132.508V20.11H148.128V22.354H135.06V31.616H148.128V33.86ZM151.777 20.11H160.885V22.354H158.179L161.061 39.69H158.597L156.309 24.994L154.043 39.69H151.579L154.439 22.354H151.777V20.11ZM160.005 28.14H162.447V20.11H164.999V39.69H162.447V30.384H160.005V28.14ZM166.737 20.11H169.289V39.69H166.737V20.11ZM174.125 20.11H189.767V27.81H183.211V29.306H190.845V31.55H173.025V29.306H180.659V27.81H174.125V20.11ZM174.125 32.87H189.767V40.548H187.215V35.114H174.125V32.87ZM176.677 25.566H187.215V22.354H176.677V25.566ZM203.381 23.52H209.013V20.11H211.565V31.55H200.829V20.11H203.381V23.52ZM216.515 40.57H200.829V32.87H216.515V35.114H203.381V38.326H216.515V40.57ZM213.963 20.11H216.515V24.708H219.023V26.952H216.515V31.55H213.963V20.11ZM209.013 25.764H203.381V29.306H209.013V25.764ZM236.092 20.11H238.644V39.69H236.092V20.11ZM229.822 22.354H221.638V20.11H232.374V39.69H229.822V22.354Z",
    fill: "#F2F0E1",
    transform: "translate(0,2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton2026);
export default __webpack_public_path__ + "static/media/button_2026.3bb72431b582f30fc42664e764834ee3.svg";
export { ForwardRef as ReactComponent };